import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEmptyTask = lazy(() => import('./svg-components/empty-task'));

const EmptyTask = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEmptyTask {...rest} />
  </Suspense>
);

export default EmptyTask;
